import { putUserCart } from 'api/cart'
import debounce from 'lodash.debounce'

export const saveUserCartDebounced = debounce(saveUserCart, 300)

function saveUserCart(items: Array<App.Checkout.AnyItem>, connectedRooms: Array<App.ConnectedRooms>) {
  return putUserCart(items, connectedRooms).catch(err => console.error(err))
}
